module.exports = __webpack_public_path__ + "static/gallery-7@2x-c32311847ec4d4c39ba6244ca233156f.jpg";